import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';

function Success() {
  const navigate = useNavigate();

  return (
    <div className="App">
      <Header />
      <div className="container">
        <div className="card">
          <div className="card-header">
            <h1>✅ Оплата успешна!</h1>
            <p className="subtitle">Ваши звезды будут зачислены в ближайшее время</p>
          </div>
          <button 
            className="payment-btn sbp-btn" 
            onClick={() => navigate('/')}
            style={{ marginTop: '20px' }}
          >
            Вернуться на главную
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Success;

